import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
// Swiper
import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

import * as apiUrl from "../../apiUrl";

SwiperCore.use([Navigation, Autoplay, Pagination]);

function MilestoneSwiper() {

    const [MilestoneSwiperData, setMilestoneSwiperData] = useState([]);

    useEffect(() => {
        const fetchMilestoneSwiper = async () => {
            try {
                const response = await fetch(
                    apiUrl.apiUrl + `/api/milestones/swiper-section`
                );
                if (!response.ok) {
                    throw new Error("Failed to fetch data");
                }
                const data = await response.json();
                const parsedData = JSON.parse(data.slide_content);
                setMilestoneSwiperData(parsedData);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchMilestoneSwiper();
    }, []);



    const pagination = {
        clickable: true,
        renderBullet: function (index, className) {
            const year = MilestoneSwiperData[index]?.year || 'Unknown';
            return `<span class="${className}">
                        <div class="circle-pagination"> 
                            <span class="number-text">${year}</span> 
                        </div>
                    </span>`;
        }
    };

    return (
        <div className='common-banner-sec milestone-swiper-sec'>
            <div className='overlay'></div>
            <Container fluid>
                <Row>
                    <Col md={12}>
                        <div className="milestone-swiper-div">

                            <Swiper className="milestone-swiper"
                                navigation={false}
                                grabCursor={true}
                                autoplay={true}
                                speed={1000}
                                spaceBetween={20}
                                slidesPerView={1}
                                loop={true}
                                pagination={pagination}
                                draggable={true}
                                centeredSlides={true}>

                                {MilestoneSwiperData.map((milestone, index) => (
                                    <SwiperSlide key={index}>
                                        <div className="milestone-div">
                                            <Row className="milestone-row">
                                                <Col md={6}>
                                                    <div className="milestone-content">
                                                        <p className='milestone-date'>{milestone.property_name}</p>
                                                        <h2 className='common-head goldenColor'>{milestone.slide_title}</h2>
                                                        <p className='common-para whiteColor'>{milestone.slide_description}</p>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </SwiperSlide>
                                ))}

                            </Swiper>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default MilestoneSwiper;
